import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Info, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";

interface AuthHeaderProps {
  backTo: string;
  infoKey: string;
}

export function AuthHeader({ backTo, infoKey }: AuthHeaderProps) {
  const { t } = useI18n();
  const [showInfo, setShowInfo] = useState(false);

  return (
    <>
      <header className="flex items-center justify-between px-4 py-2 h-12 border-b border-border mb-6">
        <Link
          to={backTo}
          className="p-2 rounded-full hover:bg-accent text-muted-foreground transition-colors"
          aria-label="Back"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <button
          onClick={() => setShowInfo(!showInfo)}
          className="p-2 rounded-full hover:bg-accent text-muted-foreground transition-colors"
          aria-label="Info"
        >
          <Info className="w-5 h-5" />
        </button>
      </header>

      {showInfo && (
        <div className="mx-4 mb-4 p-4 rounded-xl border border-border bg-muted/50 relative animate-fade-in">
          <button
            onClick={() => setShowInfo(false)}
            className="absolute top-2 right-2 p-1 rounded-full hover:bg-accent text-muted-foreground transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
          <p className="text-sm text-muted-foreground pr-6">{t(infoKey)}</p>
        </div>
      )}
    </>
  );
}
